import jQuery from 'jquery';
import { initNavigation } from './navigation.js';
import { initTestimonialsSlider } from './testimonials-slider.js';
import { initBlogCardsFilter } from './blog-cards-filter.js';
import { initFaqAccordion } from './faq-accordion.js';
import { initTableOfContents } from './table-of-contents.js';
import { initScrollObserver } from './scroll-observer.js';
import { initContactForm } from './contact-form.js';
import { initCookieConsent } from './cookie-consent.js';
import { initAnalytics } from './analytics.js';

(function ($) {
    'use strict';
    $(document).ready(function () {
        // Ne jamais exécuter les scripts front-end globaux (cookies, analytics, navigation...) dans l'admin WordPress
        if (document.body && document.body.classList.contains('wp-admin')) {
            return;
        }

        initCookieConsent();
        initAnalytics();
        initNavigation();
        initTestimonialsSlider();
        initBlogCardsFilter();
        initFaqAccordion();
        initTableOfContents();
        initScrollObserver();
        initContactForm();
        console.log('Sountsou 2026 scripts initialized.');
    });
})(jQuery);
